module.exports = __webpack_public_path__ + "img/50.3426c4d9.png";